

// member: { name: 'David Bradham', title: 'CIO', bio: 'Interesting facts!' }
const renderMember = (member) => {
    return <div className="member-container">
        <h5>{member.name} - {member.title}</h5>
        <p>{member.bio}</p>
    </div>
};

const Team = ({ members }) => {
    const memberComponents = members.map(m => renderMember(m));
    return <div className="team-container">
        <div className="team-title">Meet Our Expert Team</div>
        {memberComponents}
    </div>
};

export default Team;